import { buildURL } from '@ovh-ux/url-builder';
export function navigation(environment) {
    const getPublicURL = (application) => {
        var _a, _b;
        if (window.location.hostname === 'localhost') {
            const publicURL = new URL(window.location.href);
            const appPublicURL = (_a = environment.getApplications()[application]) === null || _a === void 0 ? void 0 : _a.publicURL;
            publicURL.hash = appPublicURL
                ? new URL(appPublicURL).hash
                : `/${application}`;
            return publicURL.href;
        }
        return (_b = environment.getApplications()[application]) === null || _b === void 0 ? void 0 : _b.publicURL;
    };
    const getURL = (application, path, params) => {
        return buildURL(getPublicURL(application), path, params);
    };
    return {
        getURL,
        navigateTo: (application, path, params) => {
            (window.top || window).location.assign(getURL(application, path, params));
        },
        reload: () => {
            (window.top || window).location.reload();
        },
    };
}
export function clientNavigation(shellClient) {
    return {
        getURL: (application, path, params) => shellClient.invokePluginMethod({
            plugin: 'navigation',
            method: 'getURL',
            args: [application, path, params],
        }),
        navigateTo: (application, path, params) => shellClient.invokePluginMethod({
            plugin: 'navigation',
            method: 'navigateTo',
            args: [application, path, params],
        }),
        reload: () => shellClient.invokePluginMethod({
            plugin: 'navigation',
            method: 'reload',
            args: [],
        }),
    };
}
export default navigation;
//# sourceMappingURL=index.js.map